import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Grid, Link, Flex } from "@chakra-ui/react";
import { LandscapeImage} from "../ImageComponents";
import Breadcrumb from "../components/Breadcrumb";

const Zines = () => {
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };

  // All zines - chronological order (most recent first)
  const zines = [
    {
      title: t('breadcrumbs.gibraltar'),
      link: "/zines/gibraltar",
      imgSrc: "/images/gibraltar-zine/VERANOCOLOR-437.jpg",
      component: LandscapeImage,
    },
    {
      title: t('breadcrumbs.hormiguero'),
      link: "/zines/hormiguero",
      imgSrc: "/images/hormiguero/hormiguero-33.jpg",
      component: LandscapeImage,
    },
    {
      title: t('breadcrumbs.theOldAndalusianWest'),
      link: "/zines/the-old-andalusian-west",
      imgSrc: "/images/old-west.jpg",
      component: LandscapeImage,
    },
  ];

  return (
    <Box
      maxWidth="1400px" // Limit page width to align with header
      margin="0 auto"
      padding="20px"
      paddingTop={{ base: "80px", md: "20px" }}
      pr="5%"
      pl="5%"
    >
      {/* Breadcrumb */}
      <Box mb={6}>
        <Breadcrumb
          items={[
            { label: t('breadcrumbs.work'), href: getLocalizedPath('/') },
            { label: t('breadcrumbs.zines') }
          ]}
        />
      </Box>

      <Grid
        templateColumns={{ base: "1fr", md: "1fr 1fr 1fr" }} // Three columns for desktop, one for mobile
        gap={5} // Consistent gap
      >
        {zines.map(({ title, link, imgSrc, component: Component }, index) => (
          <Link
            key={index}
            onClick={() => navigate(getLocalizedPath(link))}
            _hover={{ textDecoration: "none" }}
            width="100%"
            cursor="pointer"
          >
            <Flex
              flexDirection="column"
              alignItems="center"
              width="100%"
            >
              {/* Render the Appropriate Image Component with Title */}
              <Component src={imgSrc} alt={title} title={title} />
            </Flex>
          </Link>
        ))}
      </Grid>
    </Box>
  );
};

export default Zines;